import { useState } from "react";
import { Card, PageHeader, Input, Select, Btn, Table } from "../../components/shared/UIComponents";

export function DocumentsManager() {
  const docs = [
    { t: "nice day", r: "", f: "685bc9298c070" },
    { t: "Good Day", r: "Good working", f: "6895d9435b032" },
    { t: "Last day", r: "Every nice working day", f: "68988b287ff70" },
    { t: "diwali FEST", r: "", f: "689c8ebb8fade" },
  ];
  return (
    <Card>
      <PageHeader title="Upload Documents" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
          <Input label="Title" placeholder="Enter Title" />
          <Input label="Remarks" placeholder="Enter Remarks" />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Select File</label>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <input type="file" style={{ fontSize: 13, padding: "7px", border: "1.5px solid #e0e0e0", borderRadius: 8 }} />
            <span style={{ color: "#f57c00", fontSize: 12, fontWeight: 600 }}>Max File Size : 8MB(8192KB)</span>
          </div>
        </div>
        <div style={{ display: "flex", gap: 10, marginBottom: 24 }}><Btn>Upload</Btn><Btn bg="#42a5f5">Refresh</Btn></div>
        <div style={{ fontWeight: 600, color: "#546e7a", fontSize: 13, marginBottom: 10 }}>📋 Files Uploaded - To view Click on File Name</div>
        <Table columns={["SrNo", "Title", "Remarks", "File Name", "Delete", "Email"]} rows={docs}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 500 }}>{r.t}</td>,
            <td style={{ padding: "9px 12px" }}>{r.r}</td>,
            <td style={{ padding: "9px 12px" }}><a href="/" style={{ color: "#1565c0", fontSize: 12 }}>{r.f}</a></td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>🗑️</button></td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#e3f2fd", color: "#1565c0", border: "none", borderRadius: 5, padding: "4px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>Email</button></td>,
          ]}
        />
      </div>
    </Card>
  );
}

export function NoticeManager() {
  const [notices] = useState([
    { t: "General Meeting Notice", d: "AGM 2025-26 Details", dt: "2025-10-01", exp: "2025-10-31" },
    { t: "Maintenance Notice", d: "Water supply shutdown", dt: "2025-11-01", exp: "2025-11-03" },
  ]);
  return (
    <Card>
      <PageHeader title="Notice Manager" />
      <div style={{ padding: 24 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
          <Select label="Notice Category" options={["Select", "Committee Member", "Resident", "All"]} />
          <Input label="Title" placeholder="Enter Title" />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Description</label>
          <textarea placeholder="Enter Description" style={{ width: "100%", padding: "9px 12px", border: "1.5px solid #e0e0e0", borderRadius: 8, fontSize: 13, boxSizing: "border-box", height: 80 }} />
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
          <Input label="Dated" type="date" />
          <Input label="Expiry Date" type="date" />
        </div>
        <div style={{ display: "flex", gap: 16, alignItems: "flex-end", marginBottom: 24 }}>
          <div>
            <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>File Upload (Max 16 MB)</label>
            <input type="file" style={{ fontSize: 13, padding: "7px", border: "1.5px solid #e0e0e0", borderRadius: 8 }} />
          </div>
          <div>
            <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: "#78909c", marginBottom: 5, textTransform: "uppercase" }}>Show Notice</label>
            <div style={{ display: "flex", gap: 10, fontSize: 13, marginTop: 9 }}>
              <label><input type="checkbox" style={{ accentColor: "#1565c0" }} /> Show</label>
              <label><input type="checkbox" /> Hide</label>
            </div>
          </div>
          <Btn>Add New Notice</Btn>
        </div>
        <h3 style={{ textAlign: "center", color: "#1a2744", marginBottom: 16 }}>Latest Notices</h3>
        <Table columns={["SrNo", "Title", "Description", "Dated", "Expiry Date", "Edit", "Delete", "Send Email"]} rows={notices}
          renderRow={(r, i) => [
            <td style={{ padding: "9px 12px" }}>{i + 1}</td>,
            <td style={{ padding: "9px 12px", fontWeight: 500 }}>{r.t}</td>,
            <td style={{ padding: "9px 12px", fontSize: 12 }}>{r.d}</td>,
            <td style={{ padding: "9px 12px" }}>{r.dt}</td>,
            <td style={{ padding: "9px 12px" }}>{r.exp}</td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fff3e0", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>✏️</button></td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#fce8e6", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>🗑️</button></td>,
            <td style={{ padding: "9px 12px" }}><button style={{ background: "#e3f2fd", color: "#1565c0", border: "none", borderRadius: 5, padding: "4px 10px", cursor: "pointer", fontSize: 12, fontWeight: 600 }}>Send Email</button></td>,
          ]}
        />
      </div>
    </Card>
  );
}

export default DocumentsManager;
